<template>
  <div>
    <!-- <v-row>
      <v-col cols="12" span="12">
        <v-icon color="success" large class="avatar-icon">mdi-numeric-1</v-icon><span class="pl-4 font-weight-light"><i>Select the range of prices here</i></span>
      </v-col>        
    </v-row> -->
    <v-row dense class="pt-3">             

<!-- datepickers -->

      <v-col cols="1" class="picker pr-5">
        <date_picker label="Date from" :date="wizardData.hsnpFromDate" :startDate="getInitialDate(wizardData.hsnpFromDate)" field="hsnpFromDate" @updateData="updateData"/> 
      </v-col>
      <v-col cols="1" class="picker pr-5">
        <date_picker label="Date until" :date="wizardData.hsnpUntilDate" :startDate="getInitialDate(wizardData.hsnpUntilDate)" field="hsnpUntilDate" @updateData="updateData"/> 
      </v-col>
      <v-col cols="1">
        <v-btn color="grey" fab x-small class="ml-4 mr-4" :disabled="!areDatesValid" @click="addDateRange"><v-icon small>mdi-arrow-down</v-icon></v-btn><span class="pt-1 grey--text">Set range</span>
      </v-col>

<!-- purchase -->

      <v-col cols="1" align="center"><v-divider vertical color="lightgray"/></v-col>
      <v-col cols="1" class="pr-5">
        <input_amount label="Purchase from" prefix="€" :amount="wizardData.purchase_amount_from" field="purchase_amount_from" @updateData="updateData"/>
      </v-col>
      <v-col cols="1" class="pr-5">
        <input_amount label="Purchase until" prefix="€" :amount="wizardData.purchase_amount_until" field="purchase_amount_until" @updateData="updateData"/>
      </v-col>

<!-- sales -->

      <v-col cols="1" align="center"><v-divider vertical color="lightgray"/></v-col>
      <v-col cols="1" class="pr-5">
        <input_amount label="Sales from" prefix="€" :amount="wizardData.sales_amount_from" field="sales_amount_from" @updateData="updateData"/>
      </v-col>
      <v-col cols="1" class="pr-5">
        <input_amount label="Sales until" prefix="€" :amount="wizardData.sales_amount_until" field="sales_amount_until" @updateData="updateData"/>
      </v-col>

<!-- buttons -->

      <v-col cols="1" align="center"><v-divider vertical color="lightgray"/></v-col>
      <v-col cols="1">
        <v-btn color="success" small v-on:click="getData()" :loading="loading" :disabled="!hasValidDates">Get data<v-icon right>mdi-database-outline</v-icon></v-btn>
      </v-col>
      <v-col cols="1">
        <v-label>Selected: {{ wizardData.toggled_prices.length }}</v-label>
      </v-col>

    </v-row>

<!-- Saved Date Ranges -->

    <v-row v-if="shouldShowChips" dense class="pt-2">
      <v-col cols="12">
        <v-chip v-for="(range, index) in wizardData.savedDateRanges" :key="index" class="mr-3 mb-2" close @click:close="removeDateRange(index)">
          {{ $moment(range.hsnpFromDate).format("DD-MM-YYYY") }} - {{ range.hsnpUntilDate ? $moment(range.hsnpUntilDate).format("DD-MM-YYYY") : "no end date" }}
        </v-chip>
      </v-col>
    </v-row>

<!-- Prices -->

    <v-row dense class="pt-1">
      <v-col cols="12">
        <v-data-table :headers="getTableHeaders()" :must-sort=true :items="hsnp_selected"
                      :disable-pagination=true  flat :height="tableHeight"
                      dense fixed-header show-select :single-select="false" v-model="component_toggled_prices"
                      item-key="hsnp_key" @item-selected="clickItem" @toggle-select-all="clickItem"
                      no-data-text="No data available" hide-default-footer class="table-font"> 
            <template v-slot:item.hsnp_datum_sort = "{item}">   
              <td>{{ $moment(item.hsnp_datum_sort).format("DD-MM-YYYY") }} </td>   
            </template>     
            <template v-slot:item.hsnp_min_inkoop = "{item}">   
              <span v-if="item.hsnp_min_inkoop !== ''">
                <td align="right">€  {{ item.hsnp_min_inkoop }}</td>   
              </span>
            </template>              
            <template v-slot:item.hsnp_purchase = "{item}">   
              <td align="right">€  {{ item.hsnp_purchase }}</td>   
            </template>  
            <template v-slot:item.hsnp_priority = "{item}">   
              <td align="center"><span v-if="item.hsnp_priority!==0"><v-avatar :size="18" style="border: solid 1px red; margin-right: 5px;"><v-icon color="red" small>mdi-parking</v-icon></v-avatar></span></td>   
            </template>              
            <template v-slot:item.hsnp_sales = "{item}">   
              <td align="right">€ {{ item.hsnp_sales }}</td>   
            </template> 
            <template v-slot:item.hsnp_margin = "{item}">   
              <td align="right">{{ item.hsnp_margin }} %</td>   
            </template>
            <template v-slot:item.hsnp_dt_sort = "{item}">   
              <td align="left">{{ item.hsnp_dt }}</td>   
            </template>                                              
        </v-data-table>
      </v-col>
    </v-row>  

  </div>
</template>

<script>

  import date_picker from '@/components/ui/date_picker.vue';
  import input_amount from '@/components/huis/hspt/ui/input_amount.vue';

  export default {
    props: {
      hspt_encrid: String,
      hsnp_selected: Array,
      wizardData: Object
    },
    components: {
      date_picker,
      input_amount,
    },
    data(){
      return{
        component_toggled_prices: this.wizardData.toggled_prices,
        loading: false,
        dataFetched: false,
      }
    },
    computed: {
      areDatesValid() {
        const fromDate = this.wizardData.hsnpFromDate;
        const untilDate = this.wizardData.hsnpUntilDate;
        
        // Check if both dates are filled
        if (!fromDate || fromDate === '' || !untilDate || untilDate === '') {
          return false;
        }
        
        // Check if until date is later than from date
        const from = new Date(fromDate);
        const until = new Date(untilDate);
        
        return until > from;
      },
      tableHeight() {
        // Base height is 385
        // If there are saved ranges, reduce height by approximately 60px (chip row height + padding)
        const baseHeight = 330;
        const rangesSectionHeight = (this.wizardData.savedDateRanges && this.wizardData.savedDateRanges.length > 0) ? 65 : 0;
        return this.wizardData.wInnerHeight - baseHeight - rangesSectionHeight;
      },
      hasValidDates() {
        const fromDate = this.wizardData.hsnpFromDate;
        const untilDate = this.wizardData.hsnpUntilDate;
        
        // At least one date must be filled
        return (fromDate && fromDate !== '') || (untilDate && untilDate !== '');
      },
      shouldShowChips() {
        // Always show chips when there are ranges to avoid confusion
        return this.wizardData.savedDateRanges && this.wizardData.savedDateRanges.length > 0;
      }
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);
      },
      getTodayISO() {
        return new Date().toISOString().substring(0, 10);
      },
      normalizeDateFrom(dateFrom) {
        // If dateFrom is empty or null, return today
        if (!dateFrom || dateFrom === '') {
          return this.getTodayISO();
        }
        
        // If dateFrom is before today, return today
        const today = new Date(this.getTodayISO());
        const from = new Date(dateFrom);
        
        if (from < today) {
          return this.getTodayISO();
        }
        
        return dateFrom;
      },
      sortDateRanges() {
        // Sort the savedDateRanges array in place
        // Ranges with end dates first (sorted by from date), then ranges without end dates
        this.wizardData.savedDateRanges.sort((a, b) => {
          // If one has no end date and the other does, put the one without end date last
          if (a.hsnpUntilDate === null && b.hsnpUntilDate !== null) return 1;
          if (a.hsnpUntilDate !== null && b.hsnpUntilDate === null) return -1;
          
          // Otherwise, sort by from date (oldest first)
          const dateA = new Date(a.hsnpFromDate || this.getTodayISO());
          const dateB = new Date(b.hsnpFromDate || this.getTodayISO());
          return dateA - dateB;
        });
      },
      addDateRange() {
        // Check for maximum 8 ranges
        if (this.wizardData.savedDateRanges.length >= 8) {
          let message = {
            clear: false,
            type: 'error',
            caption: 'Maximum ranges reached',
            message: 'Only 8 ranges are permitted.'
          };
          this.$emit('showMessage', message);
          return;
        }
        
        const today = new Date(this.getTodayISO());
        const newUntil = new Date(this.wizardData.hsnpUntilDate);
        
        // Check if the range is fully in the past
        if (newUntil < today) {
          let message = {
            clear: false,
            type: 'error',
            caption: 'Invalid date range',
            message: 'The date range cannot be fully in the past.'
          };
          this.$emit('showMessage', message);
          return;
        }
        
        // Normalize fromDate: if it's in the past, set it to today
        let normalizedFromDate = this.wizardData.hsnpFromDate;
        const fromDate = new Date(this.wizardData.hsnpFromDate);
        if (fromDate < today) {
          normalizedFromDate = this.getTodayISO();
        }
        
        const newFrom = new Date(normalizedFromDate);
        
        // Check for overlaps with existing ranges
        const hasOverlap = this.wizardData.savedDateRanges.some(range => {
          const existingFrom = new Date(range.hsnpFromDate);
          
          // If existing range has no end date, it extends indefinitely
          if (range.hsnpUntilDate === null) {
            // New range overlaps if its start or end is >= existing start
            return newFrom >= existingFrom || newUntil >= existingFrom;
          }
          
          const existingUntil = new Date(range.hsnpUntilDate);
          
          // Two ranges overlap if: newFrom <= existingUntil AND newUntil >= existingFrom
          return newFrom <= existingUntil && newUntil >= existingFrom;
        });
        
        if (hasOverlap) {
          let message = {
            clear: false,
            type: 'warning',
            caption: 'Overlapping dates',
            message: 'The selected date range overlaps with an existing range.'
          };
          this.$emit('showMessage', message);
          return;
        }
        
        this.wizardData.savedDateRanges.push({
          hsnpFromDate: normalizedFromDate,
          hsnpUntilDate: this.wizardData.hsnpUntilDate
        });
        
        // Sort the ranges after adding
        this.sortDateRanges();
        
        // Mark that ranges have been added manually
        this.dataFetched = true;
        
        // Set from date to until date + 1 day and clear until date
        const nextFromDate = new Date(this.wizardData.hsnpUntilDate);
        nextFromDate.setDate(nextFromDate.getDate() + 1);
        const nextFromDateISO = nextFromDate.toISOString().substring(0, 10);
        
        this.updateData({"field": "hsnpFromDate", "value": nextFromDateISO});
        this.updateData({"field": "hsnpUntilDate", "value": null});
      },
      removeDateRange(index) {
        this.wizardData.savedDateRanges.splice(index, 1);
        // Sort after removal to maintain order
        this.sortDateRanges();
      },
      clickItem(){
        // net te vroeg, de array is nog niet bijgewerkt hier, maar na 200 millies wel
        this.delay(200).then(() => this.updateData({"field": "toggled_prices", "value": this.component_toggled_prices}));
      },
      delay(time){
        return new Promise(resolve => setTimeout(resolve, time));
      },
      getInitialDate(v){
        if (v === null || v === '') {
          return new Date().toISOString().substring(0, 10);
        } else {
          return v;
        }
      },
      getTableHeaders(){
        return [
                { text: "", value: "hsnp_datum_day", sortable: false, width: "1%"},
                { text: "Datum", value: "hsnp_datum_sort",sortable: false},                
                { text: "", value: "hsnp_priority",sortable: false, width: "1%"},
                { text: "Purchase price", align: "end", sortable: false, value: "hsnp_purchase"},
                { text: "Sales price", align: "end", sortable: false, value: "hsnp_sales"},
                { text: "Margin", align: "end", sortable: false, value: "hsnp_margin"},
                { text: "Arrival", value: "hsnp_van", sortable: false},
                { text: "Departure", value: "hsnp_tm", sortable: false},
                { text: "Min. nights", align: "center",  value: "hsnp_min_aant_nacht", sortable: false},
                { text: "Min. purchase", align: "end", sortable: false, value: "hsnp_min_inkoop"},
                { text: "Planning", align: "center", value: "hsnp_planning", sortable: false},
                { text: "Week price", align: "end", value: "hsnp_weekprijs", sortable: false},
                { text: "Cleaning", align: "center", value: "hsnp_schoonmaak", sortable: false},                
                { text: "Updated", value: "hsnp_dt_sort", sortable: true},
              ];
      },             
      getData(){
        // If no ranges exist, create one with the current dates from the datepickers
        if (this.wizardData.savedDateRanges.length === 0) {
          const normalizedFromDate = this.normalizeDateFrom(this.wizardData.hsnpFromDate);
          this.wizardData.savedDateRanges.push({
            hsnpFromDate: normalizedFromDate,
            hsnpUntilDate: this.wizardData.hsnpUntilDate || null
          });
        }
        
        // Mark that data has been fetched so ranges are shown
        this.dataFetched = true;
        
        this.loading = true;
        this.$axios
        .post("ares/json/ares/huis/hspt/hsnp/getHsnpUpdateSelectionv3.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsnpUpdateSelection"
          },
          getHsnpUpdateSelection: {
            hspt_encrid: this.hspt_encrid,
            selection: this.wizardData,
          }
        })
        .then(res => {
          if (res.data.error) {            
            let message = new Object();
            message.clear = false;
            message.type = 'error';
            message.caption = 'Time out';
            message.message = res.data.error.message; 
            this.$emit('showMessage', message);
            this.loading = false;
          }  else { 
            this.component_toggled_prices = []; // reset on data collection
            this.updateData({"field": "selected_prices", "value": res.data.getHsnpUpdateSelection.prices});
            this.updateData({"field": "toggled_prices", "value": this.component_toggled_prices});
            this.loading = false;
          }
        })          
      } 
    }
  }
</script>

<style scoped>
  .picker{
    min-width: 150px !important;
  }
  .avatar-icon{
    border-radius: 200px;
    width: 30px;
    height: 30px;
    border: solid 2px green;
  }
  .table-font{
    font-size: 12px !important; 
  }

</style>